import React from "react";
import Modal from "react-bootstrap/Modal";
import { IRequestFolioModalProps } from "./RequestFolioModalProps";
import { StyledDialog } from "./RequestFolioModalHelpers";
import { Button } from "react-bootstrap";
import { generateJWTToken } from "../../../utils/auth0Client";

const RequestFolioModal: React.FC<IRequestFolioModalProps> = (props) => {
  const modalId = "request-folio-modal";
  const [isStep1, setIsStep1] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const arrival = new Date(props?.checkIn).toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const departure = new Date(props?.checkout).toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const folioTitle = isStep1
    ? "Request Folio"
    : error
    ? "Error Occured"
    : "Request Received";

  const modalBodyTitle = isStep1
    ? "Stay Details"
    : error
    ? "Error"
    : "Thank You";

  const submitFolioRequest = async () => {
    setIsSubmitting(true);
    try {
      const token = generateJWTToken();
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      const request = {
        id: props?.hotelId,
        firstName: props?.firstName,
        confirmation: props?.confirmation,
        lastName: props?.lastName,
        phone: props?.phone,
        email: props?.email,
        details: "Request Folio",
        directForm: "direct-folio",
        checkIn: props?.checkIn,
        loyaltyNumber: props?.loyaltyNumber,
      };
      const url =
        process.env.GATSBY_SONESTA_FUNCTION_URL ||
        "https://functions.sonesta.com";
      const sonestaFunction =
        process.env.GATSBY_FOLIO_FUNCTION || "guestRelationsQA";
      const response = await fetch(
        `${url}/.netlify/functions/${sonestaFunction}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(request),
        }
      );
      const result = await response.json();
      if (result?.error) {
        setError(true);
      }
      setIsStep1(false);
    } catch (error) {
      setError(true);
      setIsStep1(false);
    }
  };

  return (
    <StyledDialog
      show={props.show}
      onHide={props.onHide}
      aria-labelledby={`${modalId}-title`}
      aria-describedby={`${modalId}-body`}
      role="dialog"
    >
      <Modal.Header closeButton aria-label="Close Modal">
        <div className="ModalTitle">
          <Modal.Title
            className="title"
            id={`${modalId}-title`}
            aria-live="assertive"
          >
            {folioTitle}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body id={`${modalId}-body`} aria-live="polite">
        <div className="modal-body-title">{modalBodyTitle}</div>
        <div className="modal-body-hotel-info">
          {isStep1 ? (
            <>
              <span>{props?.hotelName}</span>
              <span>
                {arrival} - {departure}
              </span>
              <span>Confirmation #: {props?.confirmation}</span>
            </>
          ) : error ? (
            <span>Something went wrong, please try again later.</span>
          ) : (
            <span>
              A copy of your folio (PDF) will be sent to your email inbox.
              Delivery can take up to 48 hours.
            </span>
          )}
        </div>
        {isStep1 ? (
          <div className="modal-body-email">
            <span className="email-lable">Email folio to:</span>
            <span>{props?.email}</span>
          </div>
        ) : null}
        <div>
          {isStep1 ? (
            <Button
              type="button"
              id="send-folio-request-button"
              className="submit-folio-button"
              onClick={submitFolioRequest}
            >
              Email Folio
            </Button>
          ) : (
            <Button
              type="button"
              id="close-folio-modal-button"
              className="close-modal-button"
              onClick={props.onHide}
            >
              Close
            </Button>
          )}
        </div>
      </Modal.Body>
    </StyledDialog>
  );
};
export default RequestFolioModal;
